// src/components/OnlineUsersBadge.jsx
import useOnlineUsers from "../hooks/useOnlineUsers";

export default function OnlineUsersBadge() {
  const onlineUsers = useOnlineUsers();

  return (
    <div className="relative group">
      <div className="flex items-center gap-2 px-4 py-2 rounded-full border border-gray-200 dark:border-white/10 bg-white/60 dark:bg-[#1a1625]/60 backdrop-blur">
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75"></span>
          <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500"></span>
        </span>

        <span className="text-sm text-gray-700 dark:text-gray-300">
          Live • {onlineUsers}
        </span>
      </div>

      {/* Tooltip au hover */}
      <div
        className="
          absolute top-8 left-1/2 -translate-x-1/2
          opacity-0 group-hover:opacity-100
          transition duration-300
          pointer-events-none
        "
      >
        <div
          className="
            px-3 py-1.5 text-xs rounded-md
            bg-black text-white
            dark:bg-white dark:text-black
            shadow-lg whitespace-nowrap
          "
        >
          {onlineUsers} visiteur{onlineUsers > 1 ? "s" : ""} actuellement
        </div>
      </div>
    </div>
  );
}
